import Login from '../views/pages/Login';
import ForgotPassword from '../views/pages/ForgotPassword';
import ResetPassword from '../views/pages/ResetPassword';
import Activate from '../views/pages/Activate';
import Register from '../views/pages/Register';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/forgot-password',
    name: 'Esqueci minha senha',
    component: ForgotPassword,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/reset-password',
    name: 'Redefinir senha',
    component: ResetPassword,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/activate',
    name: 'Ativar conta',
    component: Activate,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/register',
    name: 'Criar conta',
    component: Register,
    layout: '/auth',
    invisible: true,
  },
];

export default routes;
